import React, { useRef } from 'react';
var VeltCommentSidebarV2FilterContainerSectionOptionCheckbox = function (props) {
    var checked = props.checked, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comment-sidebar-filter-container-v2-section-option-checkbox", { ref: ref, checked: [true, false].includes(checked) ? (checked ? 'true' : 'false') : undefined, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltCommentSidebarV2FilterContainerSectionOptionCheckbox;
